import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ApiloaderService } from 'src/app/shared/loaders/apiloader/apiloader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private apiLoaderService: ApiloaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoader = req.headers.get('X-Skip-Loader') === 'true';

    if (!skipLoader) {
      this.apiLoaderService.setRequest(req);
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!skipLoader) {
          this.apiLoaderService.removeRequest(req);
        }
      })
    );
  }
}
